import { Modifier, RichUtils, EditorState, SelectionState, AtomicBlockUtils } from 'draft-js';
import * as R from 'ramda';
import ImageComponent from './EditorToolbar/ImagePicker/Image';
import decorator from './decorator';


export const handleTab = (e, editor) => {
    const tab = '\t';
    const { currentContent, currentSelection, currentStyle } = getEditorData(editor);

    const blockType = currentContent.getBlockForKey(currentSelection.getStartKey()).getType();
    const modifier = Modifier.replaceText(currentContent, currentSelection, tab, currentStyle);
    return R.contains('list', blockType) ? RichUtils.onTab(e, editor, 4) : EditorState.push(editor, modifier, 'insert-characters')
};

export const getBlockStyle = (block) => {
    switch (block.getType()) {
        default:
        case 'align-left': return 'DraftEditor-alignLeft';
        case 'align-center': return 'DraftEditor-alignCenter';
        case 'align-right': return 'DraftEditor-alignRight';
    }
};

export const blockRenderer = (block, editorState) => {

    if (block.getType() === 'atomic') {
        const entityKey = block.getEntityAt(0);
        const entity = editorState.getCurrentContent().getEntity(entityKey);
        const data = entity.getData();

        return {
            component: ImageComponent,
            editable: false,
            props: {
                url: data.url,
                alt: data.alt
            }
        };
    };
};


export const insertImage = (editorState, entityData) => {

    const { currentContent } = getEditorData(editorState);

    const contentStateWithEntity = currentContent.createEntity(
        'IMAGE',
        'IMMUTABLE',
        entityData
    );

    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

    return AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
};

export const insertEntityType = (editorState, data, type) => {

    const newEditorState = EditorState.set(moveFocusToInput(editorState), { decorator })

    const { currentContent, currentSelection, currentStyle } = getEditorData(newEditorState);

    const contentStateWithEntity = currentContent.createEntity(
        type,
        'IMMUTABLE',
        data
    );

    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

    const textModifier = currentSelection.isCollapsed() ? Modifier.insertText : Modifier.replaceText

    const insertedEntity = textModifier(
        currentContent,
        currentSelection,
        data.text,
        currentStyle,
        entityKey
    );

    return EditorState.push(newEditorState, insertedEntity, 'insert-characters');
}

export const styleOverride = (editorState) => {

    const { currentContent, currentStyle, currentSelection } = getEditorData(editorState);

    const newState = moveFocusToInput(editorState);

    let nextEditorState = EditorState.push(newState, currentContent, 'change-inline-style')

    if (currentSelection.isCollapsed()) {
        nextEditorState = currentStyle.reduce((_, style) => {
            return RichUtils.toggleInlineStyle(newState, style);
        }, nextEditorState);
    }

    return nextEditorState
};

function moveFocusToInput(editorState) {

    const { currentSelection } = getEditorData(editorState);
    const key = currentSelection.getFocusKey()
    const offset = currentSelection.getFocusOffset()
    const start = currentSelection.getStartOffset();
    const end = currentSelection.getEndOffset();

    const collapsedSelection = new SelectionState({
        anchorKey: key,
        anchorOffset: offset,
        focusKey: key,
        focusOffset: offset
    });

    const normalSelection = new SelectionState({
        anchorKey: key,
        anchorOffset: start,
        focusKey: key,
        focusOffset: end
    })

    const selection = currentSelection.isCollapsed() ? collapsedSelection : normalSelection;

    return EditorState.forceSelection(editorState, selection);
}

function getEditorData(editorState) {
    return {
        currentContent: editorState.getCurrentContent(),
        currentSelection: editorState.getSelection(),
        currentStyle: editorState.getCurrentInlineStyle()
    }
}
